angular.module('picmonicpublic')
    .controller('TryItFreeController', ['$scope', '$stateParams', '$modal', '$cookies', '$interval', 'PackageOptionsResource', 'UserService', 'MarketOptionsConfig', '$window', 'SplitTestService', function ($scope, $stateParams, $modal, $cookies, $interval, PackageOptionsResource, UserService, MarketOptionsConfig, $window, SplitTestService) {
        $scope.market = MarketOptionsConfig.getMarketBySlug($stateParams.slug);
        $scope.UserService = UserService;

        $scope.splitTest = 'no_discount';
        
        /*
        if (!window.pls_config.user.referrer_id && !$cookies.get('referrer_code')) {
            $scope.splitTest = SplitTestService.split('try_it_free_time_based_discount', ['no_discount','discount']);
        }

        if ($scope.splitTest === 'discount') {
            var now = new Date();

            if ($cookies.get('tif_discount_expiration')) {
                expiration = $cookies.get('tif_discount_expiration');
            } else {
                expiration = parseInt(now.getTime()/1000) + ((60 * 60 * 24) - 1);
                $cookies.put('tif_discount_expiration', expiration);
            }

            $scope.tick = function() {
                $scope.diff--;

                if ($scope.diff <= 0 && interval) {
                    $interval.cancel(interval);
                    $scope.showDiscount = false;
                }

                $scope.hours = Math.floor($scope.diff / (60 * 60));
                if ($scope.hours < 10) {
                    $scope.hours = '0' + $scope.hours;
                }

                $scope.minutes = Math.floor($scope.diff / (60)) % 60;
                if ($scope.minutes < 10) {
                    $scope.minutes = '0' + $scope.minutes;
                }

                $scope.seconds = $scope.diff % 60;
                if ($scope.seconds < 10) {
                    $scope.seconds = '0' + $scope.seconds;
                }
            };

            $scope.diff = expiration - parseInt(now.getTime() / 1000);

            if ($scope.diff > 0) {
                interval = $interval($scope.tick, 1000);
                $scope.tick();

                $scope.$on('$destroy', function(){
                    if (interval) {
                        $interval.cancel(interval);
                    }
                });
                $scope.showDiscount = true;
            }
        }
        */

        if (UserService.user.user_id) {
            window.location = '/find-picmonic?market=' + $scope.market.slug;
        } else {
            UserService.setMarketCookies($scope.market.id);
        }


        $scope.marketPlans = PackageOptionsResource.query({
            market_id: MarketOptionsConfig.getMarketBySlug($stateParams.slug).id,
            group_id: 1
        },
        function(plans){

            $scope.maxPlan = $scope.minPlan = plans[0];

            angular.forEach(plans, function(plan) {
                if (plan.price > $scope.maxPlan.price) {
                    $scope.maxPlan = plan;
                }

                if (plan.price < $scope.minPlan.price) {
                    $scope.minPlan = plan;
                }
            });
        });

        $scope.goToStore = function() {
            if ($scope.minPlan && $scope.minPlan.slug) {
                $window.location = '/store/' + $scope.minPlan.slug;
            }
        }
    }]);
